module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-5.webp?bbb6bb5c";